import * as React from 'react';

const FullHeightScroll = React.memo(
    ({
        children,
        onScroll,
    }: {
        children: React.ReactNode;
        onScroll?: (e: React.UIEvent<HTMLDivElement>) => void;
    }) => {
        return (
            <div
                style={{
                    flex: 1,
                    width: '100%',
                    position: 'relative',
                }}>
                <div
                    style={{
                        position: 'absolute',
                        width: '100%',
                        height: '100%',
                        overflowY: 'auto',
                    }}
                    onScroll={onScroll}>
                    {children}
                </div>
            </div>
        );
    }
);

export default FullHeightScroll;
